<template>
  <div>
    <div class="me-info" style="padding-bottom: 60px;">
      <ul class="me-info-items f-cbli">
        <li class="me-info-item">
          <div class="me-info-name">头像</div>
          <div class="me-info-avatar f-img-box">
            <img :src="data.avatar?data.avatar:studentAvatar">
            <input type="file" class="me-info-avatar-upload" @change="uploadAvatar"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">昵称</div>
          <div class="me-info-input">
            <input type="text" v-model="data.nick_name"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">年龄</div>
          <div class="me-info-input">
            <input type="text" v-model="data.age"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">性别</div>
          <div class="me-info-input">
            <input type="text" :value="conversionSex(sex)" @click="selectSex" readonly/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">地区</div>
          <div class="me-info-input">
            <div class="me-info-select">
              <select @change="changeProvince" class="provinceSelector">
                <option value="-1">省份</option>
                <option v-for="(item,index) in area" :value="index">{{ item.name }}</option>
              </select>
              <select @change="changeCity" class="citySelector">
                <option>城市</option>
                <template v-if="selectedProvinceIndex != -1">
                  <option v-for="(item,index) in area[selectedProvinceIndex].cities" :value="item.id">{{ item.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">学员身份</div>
          <div class="me-info-input">
            <div class="me-info-select">
              <select @change="changeidentity" class="identitySelector">
                <option value="1">普通群众</option>
                <option value="2">公共数字文化从业人员</option>
              </select>
            </div>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">邮箱</div>
          <div class="me-info-input">
            <input type="text" v-model="data.email" v-validate="'email'" name="email"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">手机</div>
          <div class="me-info-input">
            <input type="text" v-model="data.mobile" v-validate="'mobile'" name="mobile"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">职业</div>
          <div class="me-info-input">
            <input type="text" v-model="data.occupation"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">证件照</div>
          <div class="me-info-avatar f-img-box">
            <img
              :src="
                data.identification_photo
                  ? data.identification_photo
                  : studentAvatar
              "
            />
            <input
              type="file"
              class="me-info-idphoto-upload"
              @change="uploadIdentificationPhoto"
            />
          </div>
        </li>
      </ul>
      <div class="me-info-button">
        <button type="button" @click="submitInfo">确定</button>
      </div>
    </div>
    <mt-actionsheet
      :actions="actions"
      v-model="showSexSelector"
      cancelText="">
    </mt-actionsheet>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      actions: [
        {
          name: "男",
          method: () => {
            this.sex = 1;
          }
        }, {
          name: "女",
          method: () => {
            this.sex = 2;
          }
        }, {
          name: "保密",
          method: () => {
            this.sex = 0;
          }
        }
      ],
      sex: -1,
      showSexSelector: false,
      area: [],
      selectedProvinceIndex: -1,
      uploadData: null
    }
  },
  created() {
    //获取个人信息填充表单
    var infoPromise = this.$api.get("", {
      api: "/v1/my/index",
      user_type: this.tools.getCookie("user_type")
    }, res => {
      var data = res.data;
      this.data = data;
      this.sex = data.sex;
      for (var i = 0; i < 2; i++) {
        if (this.data.identity == document.querySelectorAll(".identitySelector option")[i].value) {
          document.querySelectorAll(".identitySelector option")[i].selected = true;
        }
      }
    })
    //获取省市区列表
    var areaPromise = this.$api.get("", {
      api: "/v1/base/getCityList"
    }, res => {
      this.area = res.data;
    })
    //个人信息和省市区列表获取成功后，进行填充
    Promise.all([infoPromise, areaPromise]).then(() => {
      var area = this.area;
      for (var i = 0; i < area.length; i++) {
        for (var j = 0; j < area[i].cities.length; j++) {
          if (area[i].cities[j].id == this.data.area) {
            //匹配到和个人信息相符的地区
            this.selectedProvinceIndex = i;
            document.querySelectorAll(".provinceSelector option")[i + 1].selected = true;
            this.$nextTick(((num) => {//因为修改selectedProvinceIndex后才能选择城市，所以把选择城市代码放在nexttick中
              return function () {
                document.querySelectorAll(".citySelector option")[num + 1].selected = true;
              }
            })(j))
          }
        }
      }
    })
    //设置验证的语言
    this.$validator.localize('zh_CN');
    //自定义规则，验证手机号
    var mobileValidator = {
      getMessage: function (field, arg) {
        return "手机号格式不正确";
      },
      validate: function (value, arg) {
        if (value.match(/^1\d{10}$/)) {
          return true;
        } else {
          return false;
        }
      }
    }
    this.$validator.extend('mobile', mobileValidator);
    this.$validator.attach({
      name: 'mobile',
      rules: 'mobile'
    });
  },
  methods: {
    selectSex() {
      this.showSexSelector = true;
    },
    conversionSex(sex) {
      var sexStr = "";
      switch (this.sex) {
        case 1:
          sexStr = "男";
          break;
        case 2:
          sexStr = "女";
          break;
        case 0:
          sexStr = "保密";
          break;
      }
      return sexStr;
    },
    submitInfo() {
      this.$validator.validate().then(result => {
        if (!result) {
          var errorItems = this.errors.items;
          this.$messagebox.alert(errorItems[0].msg);
        } else {
          this.$api.get("", {
            api: "/v1/my/edit",
            user_type: this.tools.getCookie("user_type"),
            nick_name: this.data.nick_name,
            area: this.data.area,
            email: this.data.email,
            mobile: this.data.mobile,
            avatar: this.data.avatar,
            sex: this.sex,
            identity: this.data.identity,
            occupation: this.data.occupation,
            age: this.data.age,
            identification_photo: this.data.identification_photo,
          }, res => {
            this.$toast("更新成功！");
          }, res => {
            this.$toast(res.msg);
          })
        }
      });
    },
    changeProvince(evt) {
      var index = evt.target.value;
      if (index) {
        this.selectedProvinceIndex = index;
        document.querySelectorAll(".citySelector option")[0].selected = true;//重置城市选择的位置
      }
    },
    changeCity(evt) {
      this.data.area = evt.target.value;
    },
    changeidentity(evt) {
      this.data.identity = evt.target.value;
    },
    uploadAvatar(evt) {
      new Promise((resolve, reject) => {
        if (!this.uploadData) {
          //检测如果不存在上传图片需要的参数，则获取
          this.$api.get("", {
            api: '/v1/upload/upload',
            user_type: this.tools.getCookie("user_type")
          }, res => {
            this.uploadData = res.data;
            resolve();
          })
        } else {
          resolve();
        }
      }).then(() => {
        //已获取到上传图片需要的参数，开始上传
        var uploadData = this.uploadData;
        var formData = new FormData();
        formData.append("file", document.querySelector(".me-info-avatar-upload").files[0]);
        //将token等信息加入到formData
        for (var prop in uploadData) {
          formData.append(prop, uploadData[prop]);
        }
        var up_url = '';
        if (window.location.href.indexOf('demo') != -1 || window.location.href.indexOf('localhost') != -1) {
          up_url = 'https://demo-server.chaoxing.com/v1/upload/upload';
        } else {
          up_url = 'https://server-mooc.chaoxing.com/v1/upload/upload';
        }
        this.axios({
          url: up_url,
          data: formData,
          method: "post",
          headers: {
            'Content-Type': "multipart/form-data"
          }
        })
          .then((res) => {
            console.log(res)
            this.data.avatar = res.data.data.file_url;
          })
      })

    },
    uploadIdentificationPhoto(evt) {
      new Promise((resolve, reject) => {
        if (!this.uploadData) {
          //检测如果不存在上传图片需要的参数，则获取
          this.$api.get(
            "",
            {
              api: "/v1/upload/upload",
              user_type: this.tools.getCookie("user_type"),
            },
            (res) => {
              this.uploadData = res.data;
              resolve();
            }
          );
        } else {
          resolve();
        }
      }).then(() => {
        //已获取到上传图片需要的参数，开始上传
        var uploadData = this.uploadData;
        var formData = new FormData();
        formData.append(
          "file",
          document.querySelector(".me-info-idphoto-upload").files[0]
        );
        //将token等信息加入到formData
        for (var prop in uploadData) {
          formData.append(prop, uploadData[prop]);
        }
        var up_url = "";
        if (
          window.location.href.indexOf("demo") != -1 ||
          window.location.href.indexOf("localhost") != -1
        ) {
          up_url = "https://demo-server.chaoxing.com/v1/upload/upload";
        } else {
          up_url = "https://server-mooc.chaoxing.com/v1/upload/upload/img/1";
        }
        this.axios({
          url: up_url,
          data: formData,
          method: "post",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((res) => {
          this.data.identification_photo = res.data.data.file_url;
        });
      });
    },
  }
}
</script>

<style>
.me-info-item {
  height: 1.68rem;
  margin: 0 0.4rem;
  border-bottom: 1px solid #e6e6e6;
}

.me-info-name {
  float: left;
  color: #333;
  font-size: 0.426rem;
  line-height: 1.68rem;
}

.me-info-input {
  float: right;
}

.me-info-input input {
  width: 7.066rem;
  height: 1.68rem;
  border: 0;
  font-size: 0.426rem;
  color: #999;
  text-align: right;
  background: #f2f2f2;
}

.me-info-select {
  line-height: 1.68rem;
}

.me-info-input select {
  margin-left: 0.4rem;
  width: 2.533rem;
  height: 0.8rem;
  background: #f2f2f2;
}

.me-info-avatar {
  position: relative;
  float: right;
  overflow: hidden;
  margin-top: 0.2rem;
  width: 1.306rem;
  height: 1.306rem;
  border-radius: 50%;
}

.me-info-avatar-upload {
  position: absolute;
  top: 0;
  left: 0;
  width: 1.306rem;
  height: 1.306rem;
  opacity: 0;
}

.me-info-button {
  margin-top: 0.666rem;
  text-align: center;
}

.me-info-button button {
  width: 1.76rem;
  height: 0.96rem;
  background: #EC6D3A;
  text-align: center;
  color: #fff;
  border: 0;
  font-size: 0.426rem;
  border-radius: 0.133rem;
}
.me-info-idphoto-upload {
  position: absolute;
  top: 0;
  left: 0;
  width: 1.306rem;
  height: 1.306rem;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/me-info/me-info.vue